<template>
  <div v-if="start">
    <div class="w-full">
      <vx-card>
        <vs-table
          no-data-text="Операторов нет"
          search
          stripe
          :data="operators">
          <template slot="header">
            <vs-button :to="{name: 'operators_add'}" v-can="'company.operator.manage'">Добавить оператора</vs-button>
          </template>
          <template slot="thead">
            <vs-th sort-key="name">
              Имя
            </vs-th>

            <vs-th sort-key="surname">
              Фамилия
            </vs-th>

            <vs-th sort-key="email">
              Email
            </vs-th>

            <vs-th sort-key="is_online">
              Статус
            </vs-th>

            <vs-th sort-key="email_verified">
              <div class="text-center w-full">
                Email подтвержден
              </div>
            </vs-th>


            <vs-th sort-key="last_seen_at">
              Последняя активность
            </vs-th>

            <vs-th sort-key="created_at">
              Добавлено
            </vs-th>

            <vs-th sort-key="actions" v-can="'company.operator.manage'">
              Действия
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
              <vs-td :data="data[indextr].name">
                <div class="flex items-center">
                  <vs-avatar
                    :src="data[indextr].profile_image_url"
                    :text="data[indextr].name"
                    class="mr-4"
                  />
                  {{ data[indextr].name.split(' ')[0] }}
                </div>
              </vs-td>

              <vs-td :data="data[indextr].name">
                {{ data[indextr].name.split(' ')[1] }}
              </vs-td>

              <vs-td :data="data[indextr].email">
                {{ data[indextr].email }}
              </vs-td>

              <vs-td :data="data[indextr].is_online">
                <span v-if="data[indextr].is_online" class="flex items-center px-2 py-1 rounded">
                  <div class="h-3 w-3 rounded-full mr-2 bg-success"></div> Онлайн
                </span>
                <span v-else class="flex items-center px-2 py-1 rounded">
                  <div class="h-3 w-3 rounded-full mr-2 bg-danger"></div> Оффлайн
                </span>
              </vs-td>

              <vs-td :data="data[indextr].email_verified">
                <div class="text-center">
                  <vs-icon v-if="data[indextr].email_verified" icon="done" size="small" color="success"></vs-icon>
                  <vs-icon v-else icon="clear" size="small" color="danger"></vs-icon>
                </div>
              </vs-td>

              <vs-td :data="data[indextr].last_seen_at">
                {{ data[indextr].last_seen_at | relativeDate}}
              </vs-td>

              <vs-td :data="data[indextr].created_at">
                {{ data[indextr].created_at | momentFormat }}
              </vs-td>

              <vs-td :data="data[indextr].actions" v-can="'company.operator.manage'">
                <div class="flex items-center justify-end">
                  <vs-button
                    type="flat"
                    size="large"
                    icon-pack="feather"
                    icon="icon-edit"
                    :to="{name: 'operators_edit', params: {email: data[indextr].email}}"></vs-button>
                  <vs-button
                    type="flat"
                    size="large"
                    icon-pack="feather"
                    icon="icon-trash-2"
                    @click="clickOnDelete(indextr)"></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>
</template>

<script>
import Operators from '../../api/http/models/Operators'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      start: false,
      deletingOperator: {},
      operators: []
    }
  },
  computed: mapGetters(['authUserCompany']),
  methods: {
    clickOnDelete (id) {
      this.deletingOperator = this.operators[id]
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Вы точно хотите удалить «‎‎${this.deletingOperator.name}» из Yolker?`,
        text: `Оператор «‎‎${this.deletingOperator.name}» будет удален из системы.`,
        accept: this.deleting,
        acceptText: 'Да, хочу',
        cancelText: 'Нет'
      })
    },
    async deleting () {
      const response = await Operators.deleteOne(this.authUserCompany.slug, this.deletingOperator.email)

      if (response.status === 'success') {
        this.operators = this.operators.filter(operator => this.deletingOperator.email !== operator.email)
        this.$vs.notify({
          color: 'success',
          title: 'Удаление прошло успешно',
          text: `Оператор «‎‎${this.deletingOperator.name}» был удален из системы`
        })
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Произошла ошибка',
          text: ''
        })
      }
    }
  },
  async created () {
    const response = await Operators.getAll(this.authUserCompany.slug, true)

    if (response.data) {
      this.operators = response.data.reverse()
    }

    this.start = true
  }
}
</script>
